import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import {
    getAlbums,
    getMediasSent,
    getStash,
    setAlbumAction,
    setStash,
    setStashBusy,
    setStashHasMore,
    setStashMedias,
    setStashSelectedR,
    setStashSidebar,
    setStashTabSelected,
    setStashToGetInfo,
    setStashAlbumMedias,
    setStashActiveAlbum,
    setOrderModal,
    setAddMediaToAlbum,
    setStashFilter,
    getSoldPostMedias,
    setTempSelected,
    resetStashMedias,
    setStashAlbumListScrollPosition,
    setStashReset,
    setStashSort,
    setStashType,
    setFilterToDate,
    setStashCurrentPage,
} from '../../../redux/actions/stash';
import { setAlert } from '../../../redux/actions';
import CloseButton from '../CloseButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropzone } from 'react-dropzone';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { ROLES } from '../../utils/constants';
import { bytesToSize } from '../../utils/helper';
import ImageModal from './image-modal';
import VideoModal from './video-modal';
import AlertConfirmModal from '../AlertConfirmModal';
import { captureException } from '@sentry/react';
import CopyToFolder from './copy-to-folder';
import Spinner from 'react-bootstrap/Spinner';

import './style.scss';
import './stash-mobile.scss';
import AlbumList from "./Album/AlbumList";
import MediaList from "./Media/MediaList";
import AlbumMediaList from "./Album/AlbumMediaList";
import { isMobile } from "react-device-detect";
import NewAlbumModal from "./Album/CreateNewAlbumModal";
import axios from 'axios';
import { Dialog, DialogContent, DialogContentText, DialogActions, Button, FormGroup, FormControlLabel, Checkbox, Typography, CircularProgress } from '@mui/material';
import Filter from './Filter';

const Stash = ({
    addMediaToAlbum,
    busy,
    show,
    stash,
    activeAlbum,
    stashSelected,
    albumAction,
    albumList,
    stashSidebar,
    stashFilter,
    mediaFiles,
    broadcastModal,
    convList,
    mediaFilesToGetInformation,
    convIndex,
    showImageModal,
    showVideoModal,
    showMoveFolder,
    userDetails,
    settings,
    tabSelected,
    source,
    showAlbumModal,
    orderModal,
    resend = () => ({}),

    maxSelection = 0,
    numUploaded = 0,
    resending = false,

    resetOnClose = false,
    stashTempSelected,
    onMessageOrPost = false,
    reset = false,
    onStashClose = () => { }
}) => {
    const dispatch = useDispatch();
    const maxFileSize = 4294967296; // 4GB

    const defaultUploadMessage = 'Please stay on Privaposts until upload is complete.';

    const [isUploading, setIsUploading] = useState(false);
    const [tmpStashSelection, setTmpStashSelection] = useState([]);
    const [addMediaAlbum, setAddMediaAlbum] = useState('');
    const [albumName, setAlbumName] = useState('');
    const [renameAlbum, setRenameAlbum] = useState('');
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState('');
    const [tmpLastMessage, setTmpLastMessage] = useState({});
    const [lastMessageDone, setLastMessageDone] = useState(false);
    const [progressbar, setProgressbar] = useState(0);
    const [filesizeErrors, setFilesizeErrors] = useState([]);
    const [tmpStashMediaInformation, setTmpStashMediaInformation] = useState({});
    const [mediaInfDone, setMediaInfDone] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [modalBody, setModalBody] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [totalSentMediaMessage, setTotalSendMediaMessage] = useState(0);
    const [totalPurchasedMedia, setTotalPurchasedMedia] = useState(0);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successfulMessage, setSuccessfulMessage] = useState('');
    const [resetPage, setResetPage] = useState(0);
    const [keepPurchased, setKeepPurchased] = useState(true);
    const [uploadMessage, setUploadMessage] = useState(defaultUploadMessage);

    const truncateString = (string, length) => string && string.length > length ? `${string.substring(0, length)}...` : string;

    const cancelTokenSource = useRef();

    const cancelRequest = useCallback(() => {
        if (cancelTokenSource.current) {
            cancelTokenSource.current.cancel('Abort request');
        }
        setShowCancelConfirm(false);
    }, []);

    const handleBeforeUnload = e => {
        const isUploading = JSON.parse(localStorage.getItem('is_uploading'));
        if (isUploading) {
            // Perform actions before the page is unloaded
            let confirmationMessage = "Leaving will cancel your file upload, Are you sure you want to leave?";
            // Standard for most browsers
            e.returnValue = confirmationMessage;

            // For some older browsers
            return confirmationMessage;
        }
    };

    useEffect(() => {
        localStorage.setItem('is_uploading', isUploading);
    }, [isUploading]);

    useEffect(() => {
        if (source === 'messenger' && !broadcastModal) {
            dispatch(getMediasSent());
            dispatch(getSoldPostMedias());
        }

        const onBeforeUnload = e => handleBeforeUnload(e);

        window.addEventListener("beforeunload", onBeforeUnload);

        return () => {
            document.removeEventListener("beforeunload", onBeforeUnload);
            dispatch(setStashSort('DESC'));
            dispatch(setStashType('all'));
            dispatch(setFilterToDate(''));

            if (tabSelected === 'album') {
                dispatch(setStashTabSelected('media'));
            }

            setUploadMessage(defaultUploadMessage);
        };
    }, []);

    const updateActiveAlbumDetails = () => {
        dispatch(getAlbums());
        const activeAlbumId = activeAlbum.id;

        const selectedAlbum = albumList.filter((album) => album.id === activeAlbumId);

        if (selectedAlbum) {
            dispatch(setStashActiveAlbum(selectedAlbum[0]));
        }

        dispatch(setStashSelectedR([]));
        dispatch(setAlbumAction('view_album'));
        dispatch(setAddMediaToAlbum(false));

        // const payload = {
        //     activeAlbum: selectedAlbum[0],
        //     // albumAction: 'view_album',
        //     // addMediaToAlbum: false,
        //     // stashSelected: [],
        // };

        // dispatch(setStash({
        //     ...stash,
        //     ...payload,
        // }));
    };

    const addSelectedToAlbum = () => {

        const formData = new FormData();
        if (activeAlbum && Object.keys(activeAlbum).length > 0) {
            formData.append('edit_album', activeAlbum.id);
        }

        stashSelected.map((file, index) => {
            formData.append('media[]', file.media_id);
        });

        setShowLoader(true);

        axios({
            method: 'post',
            url: '/api/albums/',
            data: formData,
        })
            .then((response) => {

                setShowAlert(true);
                setShowLoader(false);
                setAlbumName('');
                setModalBody('Selected media added to album.');

                const payload = {
                    reset: false,
                    addMediaToAlbum: false,
                    stashSelected: [],
                    albumAction: 'view_album',
                };

                dispatch(setStash({
                    ...stash,
                    ...payload,
                }));

                dispatch(getStash({ reset: true, sort, type }));
                updateActiveAlbumDetails();
            })
            .catch((error) => {
                console.error(error);
            });
    };


    const getLatestMessage = async (medias) => {
        await axios.get('/api/medias/latest-message', {
            params: {
                media_ids: mediaFilesToGetInformation,
            }
        }).then(response => {
            setLastMessageDone(true);
            setTmpLastMessage(response.data);
        })
            .catch(error => {
                console.error({ error });
            });
    };

    const getStashMediaInformation = async () => {
        let otherUserId = '';
        if (convList) {
            const loggedInUser = localStorage.getItem('loggedin_user');
            const activeConversation = convList[convIndex];
            if (activeConversation && Object.keys(activeConversation).length > 0 && activeConversation['user_a'] == loggedInUser) {
                otherUserId = activeConversation['user_b'];
            }

            if (activeConversation && Object.keys(activeConversation).length > 0 && activeConversation['user_b'] == loggedInUser) {
                otherUserId = activeConversation['user_a'];
            }
        }

        await axios.get('/api/medias/message-information', {
            params: {
                media_ids: mediaFilesToGetInformation,
                sidebar: stashSidebar || broadcastModal,
                other_user: localStorage.getItem('other_user')
            }
        })
            .then(response => {
                dispatch(setStashToGetInfo([]));
                setMediaInfDone(true);
                setTmpStashMediaInformation(response.data);
            })
            .catch(error => {
                console.error({ error });
            });
    };

    useDidMountEffect(() => {
        if (mediaInfDone && lastMessageDone) {
            setLastMessageDone(false);
            setMediaInfDone(false);

            let tmp = [...mediaFiles];
            if (tmpLastMessage.length > 0) {
                for (let i = 0;i < tmpLastMessage.length;i++) {
                    // index of response from existing media files
                    const index = mediaFiles.findIndex(mediaFile => mediaFile.media_id == tmpLastMessage[i].media_id);
                    if (index >= 0) {
                        tmp[index].latest_message = tmpLastMessage[i].messages;
                        tmp[index].posts = tmpLastMessage[i].posts;
                    }
                }
            }

            // loop
            if (tmpStashMediaInformation.length > 0) {

                for (let i = 0;i < tmpStashMediaInformation.length;i++) {
                    // index of response from existing media files
                    const index = mediaFiles.findIndex(mediaFile => mediaFile.media_id == tmpStashMediaInformation[i].media_id);
                    if (index >= 0) {
                        tmp[index].messages = tmpStashMediaInformation[i].latest_message;
                    }
                }
            }

            dispatch(setStashMedias(tmp));
        }
    }, [tmpStashMediaInformation, tmpLastMessage]);

    useEffect(() => {
        if (mediaFilesToGetInformation && mediaFilesToGetInformation.length > 0) {
            getLatestMessage();
            getStashMediaInformation();
        }
    }, [mediaFilesToGetInformation]);

    useEffect(() => {
        if (show) {
            const modal = document.querySelector('.modal');

            // document.body.style.overflow = "hidden";
            if (modal) {
                modal.style.overflow = 'hidden';
            }
        } else {
            // document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [show]);

    const handleNewAlbum = () => {
        const payload = {
            showAlbumModal: true
        };

        dispatch(setStash({
            ...stash,
            ...payload
        }));
    };

    useEffect(() => {
        if (reset) {
            // setResetPage(resetPage => resetPage + 1);
            dispatch(getStash({
                per_page: 30,
                page: 1,
                stash_filter: stashFilter,
                needs_information: !stashSidebar
            }));

            dispatch(setStashReset(false));

            if (activeAlbum && Object.keys(activeAlbum).length > 0) {
                dispatch(getAlbums());
                const album = albumList.find(album => album.id === activeAlbum.id);
                if (album) {
                    dispatch(setStashActiveAlbum(album));
                }
            }

            // to show 100%
            setTimeout(() => {
                setIsUploading(false);
                setProgressbar(0);
            }, 400);
        }
    }, [reset]);

    const getUniqueFiles = (files) => {
        const uniqueFilePaths = new Set();

        files.forEach((obj) => {
            const filePath = obj.path; // Replace with your logic to extract filePath
            if (filePath) {
                uniqueFilePaths.add(filePath);
            }
        });

        return Array.from(uniqueFilePaths); // Optional: Convert to array
    };

    const onDropAccepted = useCallback((images, albumAction, activeAlbum, userRole, settings) => {
        if (images.length > parseInt(settings.max_stash_file_uploads)) {
            dispatch(setAlert({
                type: 'error',
                show: true,
                body: `
                <p>
                    Your attempt to upload ${images.length} media files all at once is not allowed.
                </p>
                <p>
                    You are permitted to upload up to ${settings.max_stash_file_uploads || 25} media files at a time from your device.
                </p>
            `
            }));

            return;
        }

        let sumFileSize = 0;
        images.forEach((file) => {
            sumFileSize += file.size;
        });

        if (sumFileSize > maxFileSize) {
            dispatch(setAlert({
                type: 'error',
                show: true,
                body: `
                <p>The selected media size exceeds the ${bytesToSize(maxFileSize)} amount that can be done in the one upload step.</p>
                <p>Please make a smaller selection of media that total less than <b>${bytesToSize(maxFileSize)}</b> and try to upload again.</p>
            `
            }));

            return;
        }

        const curr_images = images;
        const formData = new FormData();

        const axiosSource = axios.CancelToken.source();
        cancelTokenSource.current = axiosSource;

        setUploadMessage(defaultUploadMessage);

        if (userRole == ROLES.SU) { //separate upload process for SU
            formData.append('sender_id', localStorage.getItem('loggedin_user'));
            formData.append('source', source ?? 'messenger');

            setIsUploading(true);

            axios({
                method: 'post',
                url: '/api/stash-upload',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
                cancelToken: cancelTokenSource.current.token
            })
                .then((data) => {
                    // handle success
                    dispatch(setStash({
                        ...stash,
                        stashSelected: [data.data.media]
                    }));

                    setIsUploading(false);
                    localStorage.setItem('is_uploading', false);
                })
                .catch((error) => {
                    console.error({ error });
                    setIsUploading(false);

                    let filenames = '';
                    const uniqueMedia = getUniqueFiles(curr_images);

                    if (uniqueMedia.length > 0) {
                        filenames = '<ul class="text-left">';
                        uniqueMedia.forEach((file) => {
                            filenames += `<li>${file}</li>`;
                        });
                        filenames += '</ul>';
                    }

                    let message = 'Unable to upload files';
                    if (filenames.length > 0) {
                        message = `Failed to upload the following file(s)<br />${filenames}`;
                    }

                    if (error.code && error.code === 'ERR_EMPTY_RESPONSE') {
                        dispatch(setAlert({
                            show: true,
                            type: 'error',
                            body: message
                        }));
                        return;
                    }
                });

        } else {
            images.forEach((file) => {
                curr_images.push(file);
                formData.append('files[]', file);
            });

            formData.append('sender_id', localStorage.getItem('loggedin_user'));
            formData.append('source', source ?? 'messenger');

            if (albumAction === 'view_album' && activeAlbum && Object.keys(activeAlbum).length > 0) {
                formData.append('edit_album', activeAlbum.id);
            }

            setIsUploading(true);

            axios({
                method: 'post',
                url: '/api/stash-upload',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
                cancelToken: cancelTokenSource.current.token,
                onUploadProgress: progressEvent => {
                    let loaded = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    setProgressbar(loaded);

                    if (loaded >= 99) {
                        setUploadMessage('Your media is currently processing');
                    }
                },
            })
                .then((response) => {
                    setProgressbar(100);
                    dispatch(setStashHasMore(true));
                    dispatch(setStashFilter('all'));

                    dispatch(resetStashMedias());
                    setResetPage(resetPage => resetPage + 1);

                    dispatch(getStash({
                        per_page: 30,
                        page: 1,
                        stash_filter: stashFilter,
                        needs_information: !stashSidebar,

                    }));

                    if (activeAlbum && Object.keys(activeAlbum).length > 0) {
                        dispatch(getAlbums());
                        const album = albumList.find(album => album.id === activeAlbum.id);
                        if (album) {
                            dispatch(setStashActiveAlbum(album));
                        }
                    }

                    // to show 100%
                    setTimeout(() => {
                        setIsUploading(false);
                        setProgressbar(0);
                    }, 400);

                    if (response.data.errors && response.data.errors.length > 0) {
                        let message = 'Failed to upload files';
                        const errors = response.data.errors;

                        message += '<ul class="text-left">';
                        errors.forEach((error) => {
                            message += `<li>${error.filename}</li>`;
                        });
                        message += '</ul>';
                        dispatch(setAlert({
                            show: true,
                            type: 'error',
                            body: message
                        }));
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setIsUploading(false);
                    setProgressbar(0);
                    const uniqueMedia = getUniqueFiles(curr_images);

                    let filenames = '';

                    if (uniqueMedia.length > 0) {
                        filenames = '<ul class="text-left">';
                        uniqueMedia.forEach((file) => {
                            filenames += `<li>${file}</li>`;
                        });
                        filenames += '</ul>';
                    }

                    let message = 'Unable to upload files';

                    if (filenames.length > 0) {
                        message = `Failed to upload the following file(s)<br />${filenames}`;
                    }

                    if (error.code && error.code === 'ERR_EMPTY_RESPONSE') {
                        dispatch(setAlert({
                            show: true,
                            type: 'error',
                            body: message
                        }));
                        return;
                    }


                    if (error.response && error.response.data && error.response.data.errors) {
                        if (error.response.status === 422) {
                            let tmp = '';
                            Object.keys(error.response.data.errors).forEach((key) => {
                                tmp += `${error.response.data.errors[key][0]}<br />`;
                            });

                            dispatch(setAlert({
                                show: true,
                                type: 'error',
                                body: tmp
                            }));

                            return;
                        }
                    } else {
                        let message = 'Unable to upload files';

                        if (filenames.length > 0) {
                            message = `Failed to upload the following file(s)<br />${filenames}`;
                        }

                        dispatch(setAlert({
                            show: true,
                            type: 'error',
                            body: message
                        }));

                        return;
                    }
                });
        }

    }, []);


    const onDropRejected = useCallback((errors) => {
        let tmpErrors = [];
        errors.forEach(error => {
            if (error.errors.find(e => e.code === 'file-too-large')) {
                tmpErrors.push({
                    filename: error.file.name
                });
            }
        });

        if (tmpErrors.length > 0) {
            setFilesizeErrors(tmpErrors);
            let filenames = tmpErrors
                .map(e => e.filename)
                .join(', ');

            dispatch(setAlert({
                show: true,
                type: 'error',
                body: `${filenames} file(s) are too large.`
            }));
            return;
        }

        dispatch(setAlert({
            show: true,
            type: 'error',
            body: errors[0].errors[0].message
        }));
    }, []);

    useEffect(() => {
        if (filesizeErrors.length > 0) {
            let tmp = `<p>The media file you tried to upload is too big.  The maximum size is ${bytesToSize(maxFileSize)}</p><ul>`;
            filesizeErrors.forEach(error => {
                tmp += `<li>Media file name: ${error.filename}</li>`;
            });
            tmp += '</ul><p>Tip: Try trimming your media and upload again.</p>';
            dispatch(setAlert({
                show: true,
                title: 'Media file is too big to upload',
                type: 'error',
                body: tmp
            }));
        }
    }, [filesizeErrors]);

    const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({
        onDropRejected,
        onDropAccepted: (images) => onDropAccepted(images, albumAction, activeAlbum, userDetails, settings),
        maxSize: maxFileSize,
        accept: 'image/jpeg, image/png, video/mp4, video/quicktime, video/3gpp',
    });

    useEffect(() => {
        let mounted = true;

        const formData = new FormData();

        if (stashSelected && stashSelected.length > 0) {
            stashSelected.forEach((media) => {
                formData.append('media_ids[]', media.media_id);
            });

            formData.append('all', true);

            axios({
                method: 'post',
                url: '/api/check-media-stats',
                data: formData,
            }).then((response) => {
                setTotalSendMediaMessage(response.data.total_sent);
                setTotalPurchasedMedia(response.data.total_purchased);
            }).catch((error) => {
                console.error({ error });
            });
        }

        return (() => { mounted = false; });
    }, [stashSelected]);

    const confirmRemoveStash = () => {
        if (activeAlbum && Object.keys(activeAlbum).length > 0) {
            setDeleteMessage(`Remove file from album ${activeAlbum.album_name}? File will not be deleted from stash.`);
        } else {


            setDeleteMessage(`${totalSentMediaMessage} messages were sent with this media of which ${totalPurchasedMedia} were purchased.`);
        }

        setShowDeleteConfirm(true);
        // dispatch(getAlbums());
    };

    const removeStash = () => {
        if (stashSelected && stashSelected.length > 0) {
            const formData = new FormData();

            const stashSelectedIds = stashSelected.map((file, index) => {
                formData.append('media[]', file.media_id);
                return file.media_id;
            });

            dispatch(setStashBusy(true));

            if (albumAction == 'view_album' && Object.keys(activeAlbum).length > 0) {

                formData.append('album_id', activeAlbum.id);

                axios({
                    method: 'post',
                    url: '/api/albums/remove-from-album',
                    data: formData,
                })
                    .then((response) => {
                        dispatch(getAlbums());

                        let tmp = activeAlbum.medias.filter(activeMedia => !stashSelectedIds.includes(activeMedia.media_id));
                        dispatch(setStashAlbumMedias(tmp));

                        dispatch(setStashBusy(false));

                        // update count
                        let totalImage = activeAlbum.medias_img_count;
                        let totalVideo = activeAlbum.medias_video_count;

                        stashSelected.forEach(media => {
                            if (media.type.toLowerCase() === 'image') {
                                totalImage--;
                            }
                            if (media.type.toLowerCase() === 'video') {
                                totalVideo--;
                            }
                        });

                        const payload = {
                            medias_img_count: totalImage,
                            medias_video_count: totalVideo
                        };

                        const newActiveAlbum = {
                            ...activeAlbum,
                            ...payload
                        };

                        dispatch(setStashActiveAlbum(newActiveAlbum));
                        dispatch(setStashSelectedR([]));
                        dispatch(setAlert({
                            show: true,
                            type: 'info',
                            title: '',
                            body: `Media removed from ${activeAlbum.album_name} album only`
                        }));
                    })
                    .catch((error) => {
                        dispatch(setStashBusy(false));
                        captureException(error);
                        setShowDeleteConfirm(false);
                    });
            } else {
                formData.append('keep_purchased', keepPurchased);

                axios({
                    method: 'post',
                    url: '/api/medias/delete',
                    data: formData,
                })
                    .then((response) => {
                        setShowDeleteConfirm(false);
                        setKeepPurchased(true);

                        let errMessage = 'Media removed for all non-purchased PPVs.';

                        if (!keepPurchased) {
                            errMessage = 'Media successfully removed';
                        }

                        dispatch(setAlert({
                            show: true,
                            type: 'info',
                            title: '',
                            body: errMessage
                        }));

                        if (response.data.purchased == 0 || !keepPurchased) {
                            stashSelected.forEach((file, index) => {
                                const i = mediaFiles.findIndex(media => media.media_id == file.media_id);
                                if (i >= 0) {
                                    mediaFiles.splice(i, 1);
                                }
                            });

                            dispatch(setStashMedias([...mediaFiles]));
                            dispatch(setStashBusy(false));
                            dispatch(setStashSelectedR([]));
                        }

                        // if (stashFilter == 'image' || stashFilter == 'video') {
                        // } else {

                        // }

                        dispatchEvent(new Event('chatmessage/fetchConvs'));
                    })
                    .catch((error) => {
                        dispatch(setStashBusy(false));
                        captureException(error);
                        setShowDeleteConfirm(false);
                    });
            }
        } else {
            dispatch(setAlert({
                show: true,
                type: 'error',
                body: `Please select at least one media file.`
            }));
        }
    };

    const handleBackToAlbums = () => {
        const payload = {
            addMediaToAlbum: false,
            tabSelected: 'album',
            albumAction: '',
            activeAlbum: {},
            busy: false,
        };

        dispatch(setStash({
            ...stash,
            ...payload,
        }));
    };


    const handleClose = (isAdd = '') => {
        const payload = {
            filter: 'all',
            show: false,
            activeAlbum: '',
            sidebar: false,
            tabSelected: 'media',
            albums: [],
            medias: [],
            hasMore: true,
            selected: [],
            busy: false,
            mediaSent: [],
            mediaSold: [],
            stashSidebar: false,
            albumAction: '',
            stashSelected: []
        };

        let selected = stashSelected;

        selected = selected.filter((i) => {
            return !stashTempSelected.includes(i.media_id);
        });

        payload.stashSelected = selected;

        dispatch(setTempSelected([]));

        dispatch(setStash({
            ...stash,
            ...payload
        }));

        if (isAdd == 'add') {
            setTmpStashSelection([]);
        }

        // document.body.style.overflow = "auto";

        dispatch(setStashCurrentPage(1));
        onStashClose();
    };

    const handleMovetoFolder = () => {
        dispatch(setStash({
            ...stash,
            showMoveFolder: true
        }));
    };

    const addStash = () => {
        const payload = {
            show: false,
            medias: [],
            tabSelected: 'media',
            filter: 'all',
            activeAlbum: '',
            sidebar: false,
            hasMore: true,
            albums: [],
            stashSidebar: false,
            albumAction: '',
        };

        dispatch(setStash({
            ...stash,
            ...payload,
        }));

        dispatch(setTempSelected([]));
    };

    const handleTabChange = (e, tab) => {
        e.preventDefault();

        dispatch(setStashTabSelected(tab));
        dispatch(setStashAlbumListScrollPosition(0));

        if (tab === 'album') {
            dispatch(getAlbums());
        }
    };

    const handleResendInfo = () => {
        dispatch(setAlert({
            show: true,
            title: '',
            body: 'Remove this message from all unpaid subscribers and resend it now to all subscribers including newly subscribed who didn\'t receive this message',
            type: 'info'
        }));
    };

    const handleToggleOrderModal = () => {
        if (activeAlbum.medias.length > 0) {
            dispatch(setOrderModal(!orderModal));
        }
    };
    const onChangeRenameAlbum = () => { };

    const totalStashSelected = () => {
        const numSelected = stashSelected.length;
        const diff = numSelected - numUploaded;
        if (diff == 0) {
            return numUploaded;
        } else {
            return diff > 0 ? diff : 0;
        }
    };

    const [showCancelConfirm, setShowCancelConfirm] = useState(false);
    const handleCancel = () => {
        setShowCancelConfirm(true);
    };

    const handleCloseConfirm = (e, reason) => {
        if (reason !== 'backdropClick') {
            setShowCancelConfirm(false);
        }
    };

    const handleKeepPurchased = e => {
        setKeepPurchased(keepPurchased => !keepPurchased);
    };


    return <React.Fragment>
        <Dialog
            open={showCancelConfirm}
            onClose={handleCloseConfirm}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="stash__cancel"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to cancel uploading?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseConfirm}>Continue</Button>
                <Button onClick={cancelRequest} autoFocus>
                    Cancel Now
                </Button>
            </DialogActions>
        </Dialog>

        <Modal
            show={show}
            onHide={handleClose}
            backdrop='static'
            contentlabel="Stash"
            id="stash-main-modal"
            size="md"
        >
            {
                isUploading && <div className='loader-cont'>
                    <div style={{ marginBottom: '4px' }}>{uploadMessage}</div>
                    {
                        progressbar < 99
                            ? <div className="progressbar-text my-2 text-center">
                                {
                                    `${progressbar}%`
                                }
                            </div>
                            : null
                    }

                    {
                        progressbar < 99
                            ? <div className="stash-progress">
                                <div className="progress" style={{ width: '100%', height: '25px' }}></div>
                                <div
                                    role="progressbar"
                                    className={
                                        `progress-bar progress-bar-animated${progressbar >= 99 ? ' progress-bar-processing' : ''}`
                                    }
                                    style={{ width: `${progressbar < 99 ? progressbar : 100}%` }}
                                >
                                    {
                                        progressbar >= 99 ? 'Uploading media...' : ''
                                    }
                                </div>
                            </div>
                            : <div>
                                <CircularProgress
                                    size={48}
                                    color='inherit'
                                />
                            </div>
                    }

                    {
                        progressbar < 99
                            ? <div style={{ marginTop: '12px' }}>
                                <button
                                    className="btn btn-rounded btn-sm btn-primary"
                                    onClick={handleCancel}
                                >Cancel Upload</button>
                            </div>
                            : null
                    }
                </div>
            }
            <Modal.Header className="header-section">

                <div
                    className={`modal-header${(albumAction == 'confirm_album' || albumAction == 'rename_album') ? ' hide_me' : ''}`}
                    style={{ paddingBottom: '10px' }}
                >
                    <div className="stash-header">
                        <table cellSpacing={0} cellPadding={0} border={0} width="100%">
                            <tbody>
                                <tr>
                                    <td valign="middle" align="left" width="26">
                                        {
                                            albumAction == 'view_album' && <span
                                                onClick={handleBackToAlbums}
                                                className="back-albums-link">
                                                <i
                                                    className="fa-regular fa-chevron-left"
                                                    style={{ fontSize: '29px' }}
                                                />
                                            </span>
                                        }

                                        {albumAction != 'view_album' && <CloseButton
                                            className="close"
                                            style={{
                                                margin: 0,
                                                padding: 0,
                                                fontSize: '26px',
                                                marginTop: 0
                                            }}
                                            onClick={handleClose}
                                        />}
                                    </td>
                                    <td width={albumAction != "view_album" ? (albumAction == 'new_album' ? '100%' : '20%') : (addMediaAlbum != 'yes' ? '50%' : '100%')} align="left" valign="middle" style={{ paddingLeft: '5px' }}>
                                        <h5 style={{ marginBottom: 0 }}>{
                                            albumAction == "view_album"
                                                ? (isMobile ? truncateString(activeAlbum.album_name, 10)
                                                    : truncateString(activeAlbum.album_name, 23)) : 'STASH'
                                        }
                                        </h5>
                                    </td>
                                    <td align="right" valign="middle">
                                        <span className="stash_sales my-2" onClick={() => handleStatsModal('all')}><FontAwesomeIcon icon={['fas', 'dollar-sign']} /> Sales</span>

                                        <span
                                            onClick={handleMovetoFolder}
                                            className={`m-2 add_to_folder ${tabSelected != "media" ? 'hide_me' : ''}${stashSelected && stashSelected.length == 0 ? ' disabled add_to_folder_disabled' : ''}`}>
                                            <i className="fa-regular fa-folder-plus"></i>
                                        </span>

                                        {addMediaAlbum != "yes" &&
                                            <span
                                                style={{
                                                    display: 'inline',
                                                    cursor: 'pointer'
                                                }}
                                                className={`stash_remove_link m-2${(tabSelected != "media" && albumAction != 'view_album' ? ' hide_me' : '')} ${(stashSelected && stashSelected.length == 0 ? ' disabled stash_removed_disabled' : '')}`}
                                                onClick={confirmRemoveStash}
                                            >
                                                <FontAwesomeIcon icon={['far', 'trash-alt']} />
                                            </span>
                                        }

                                        {!stashSidebar && ['messenger', 'welcome_message', 'post'].includes(source) && !(tabSelected == 'album' && albumAction == '') &&
                                            <button
                                                className={`m-2 btn btn-primary btn-rounded stash-add-to-msg${stashSelected && stashSelected.length == 0 ? ' disabled stash-add-to-msg-initial' : ''}`}
                                                onClick={addStash}
                                            >ADD</button>
                                        }
                                        {
                                            (tabSelected == 'album' && albumAction === '') && <button
                                                className="btn btn-primary btn-rounded"
                                                disabled={busy}
                                                onClick={handleNewAlbum}><i className="fa-regular fa-plus"></i> New Album</button>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table cellSpacing={0} cellPadding={0} border={0} width="100%">
                            <tbody>
                                <tr>
                                    <td align="left" valign="middle">
                                        {
                                            stashSidebar && source == 'messenger' && <React.Fragment>
                                                <button
                                                    type="button"
                                                    className="stash__btn-resend btn btn-rounded btn-sm btn-primary ml-2"
                                                    style={{ marginLeft: "-1px" }}
                                                    disabled={(stashSelected && stashSelected.length <= 0) || (stashSelected && stashSelected.length > 1) || resending}
                                                    onClick={resend}
                                                >
                                                    {
                                                        resending
                                                            ? <span><Spinner size='sm' animation='border' variant='light' /> Preparing...</span>
                                                            : 'Resend'
                                                    }
                                                </button>


                                                <span
                                                    style={{
                                                        padding: "4px 7px"
                                                    }}
                                                    onClick={handleResendInfo}
                                                >
                                                    <i
                                                        className="far fa-info-circle"
                                                        style={{
                                                            color: '#0097fe',
                                                            fontWeight: '500',
                                                            fontSize: 22,
                                                            cursor: 'pointer',
                                                            lineHeight: 'inherit',
                                                            verticalAlign: 'middle'
                                                        }}
                                                    ></i>
                                                </span>
                                            </React.Fragment>
                                        }
                                        {
                                            albumAction == "view_album" && <span className="album_stats" style={{ fontWeight: 'normal', fontSize: '14px' }}>
                                                <FontAwesomeIcon icon={['fas', 'image']} /> {activeAlbum.medias_img_count} &nbsp;
                                                <FontAwesomeIcon icon={['fas', 'video']} /> {activeAlbum.medias_video_count} &nbsp;
                                                {stashSelected && stashSelected.length !== 0 && totalStashSelected() > 0 && <span className="stash__num-selected">{totalStashSelected()} selected</span>}
                                            </span>
                                        }

                                        {albumAction != "view_album" && <div className="stash__num-selected">
                                            {stashSelected && stashSelected.length !== 0 && totalStashSelected() > 0 && <span>{totalStashSelected()} selected</span>}
                                        </div>}
                                    </td>
                                    <td width="26"></td>
                                    <td style={{ paddingLeft: '5px' }}>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {
                        albumAction !== "view_album" && <div style={{ display: 'block', margin: '5px 0', fontSize: '14px' }}>
                            Upload and organize photos & videos in your Stash. Send your photos & videos as Pay Per View messages to your subscribers.
                        </div>
                    }

                    {albumAction !== "view_album" && <div
                        style={{ display: 'block' }}
                        className={`stash-media-album-filter`}
                    >
                        <ul>
                            <li
                                onClick={(e) => handleTabChange(e, 'media')}
                                className={`${tabSelected === "media" ? " active" : ""}`}
                            >
                                <span
                                    data-title="media"
                                    className="media-list-link"
                                    style={{ fontSize: '18px', cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon
                                        icon={['fas', 'photo-video']}
                                    /> Media</span>
                            </li>
                            <li
                                onClick={(e) => handleTabChange(e, 'album')}
                                className={`${tabSelected === "album" || albumAction == "new_album" ? " active" : ""}`}
                            >
                                <span
                                    data-title="albums"
                                    className="album-list-link"
                                    style={{ fontSize: '18px', cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon
                                        icon={['far', 'folder']}
                                    /> Albums
                                </span>
                            </li>
                        </ul>
                    </div>}

                    {
                        (tabSelected === 'media' || (tabSelected === 'album' && albumAction === 'view_album')) && <div
                            className={`stash-buttons mt-2 f-flex justify-content-around`}
                        >
                            {
                                (tabSelected === 'media' || (tabSelected === 'album'))
                                && <div
                                    className={`mx-2 stash-buttons-left stash-buttons-full d-flex ${addMediaToAlbum ? ' show-move' : ''}`}>
                                    {
                                        (addMediaToAlbum)
                                            ? <span
                                                className="stash-move-to-folder-btn"
                                                onClick={() => addSelectedToAlbum()}
                                            >Copy Selected Media to this Album</span>
                                            : <span className="stash-upload-btn" {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                {
                                                    isDragActive
                                                        ? <p>Drop the files here ...</p>
                                                        : <FontAwesomeIcon icon={['fas', 'photo-video']} />
                                                }Upload</span>
                                    }

                                    {activeAlbum && activeAlbum.hasOwnProperty('medias') && !addMediaToAlbum &&
                                        <span className="stash-upload-btn mx-2" onClick={handleToggleOrderModal}>
                                            <FontAwesomeIcon icon={['far', 'folder']} /> Reorder
                                        </span>
                                    }

                                    {
                                        tabSelected === 'media'
                                            ? <div className="stash-filter-container">
                                                <Filter />
                                            </div>
                                            : null
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </Modal.Header>
            <Modal.Body className="body-section">
                {
                    albumAction === ' confirm_album' && <div className={`confirm-album`}>
                        <div className="confirm-return">
                            <span className="confirm-return-button"
                                onClick={() => dispatch(setAlbumAction('album'))}><FontAwesomeIcon
                                    icon={['fas', 'chevron-left']} /> Back</span>
                        </div>
                        <div className="confirm-button">
                            <span className="rename-confirm" onClick={() => dispatch(setAlbumAction('rename_album'))}>RENAME ALBUM</span>
                        </div>
                        <div className="confirm-button">
                            <span className="rename-confirm" onClick={() => deleteAlbumConfirm()}>DELETE ALBUM</span>
                        </div>
                    </div>
                }
                {
                    albumAction === ' rename_album' && <div className={`rename-album`}>
                        <div className="rename_album_cont">
                            <h4>RENAME ALBUM</h4>
                            <p>
                                Album Name<br />
                                <input type="text" defaultValue={renameAlbum} onChange={onChangeRenameAlbum} />
                            </p>
                        </div>
                        <div className="new-album-buttons">
                            <span
                                href="#"
                                className="close-fancy"
                                onClick={() => dispatch(setAlbumAction('album'))}
                            >CANCEL</span>
                            <span
                                href="#"
                                className="save-rename-album"
                                onClick={() => updateAlbumName()}
                            >SAVE</span>
                        </div>
                    </div>
                }

                {
                    (albumAction === 'view_album' || albumAction === '') && <div id="stash-body">
                        {tabSelected === 'album' && albumAction !== 'view_album' && <AlbumList maxSelection={maxSelection} />}
                        {(tabSelected === 'media') && <MediaList
                            maxSelection={maxSelection}
                            source={source}
                            resetPage={resetPage}
                        />}
                        {(tabSelected === 'album' && albumAction === 'view_album') && <AlbumMediaList source={source} maxSelection={maxSelection} />}
                    </div>
                }
            </Modal.Body>
        </Modal>

        {showImageModal && <ImageModal />}
        {showVideoModal && <VideoModal />}
        {showMoveFolder && <CopyToFolder onMessageOrPost={onMessageOrPost} />}
        {showAlbumModal && <NewAlbumModal />}
        {showAlert && <AlertConfirmModal show={showAlert} setShow={setShowAlert} modalBody={modalBody} />}
        {
            showDeleteConfirm && <AlertConfirmModal
                show={showDeleteConfirm}
                setShow={setShowDeleteConfirm}
                modalBody={
                    <div>
                        <Typography
                            paragraph
                            align='left'
                        >

                            Remove the media from stash and all the messages that have not been purchased or free.
                        </Typography>

                        <Typography
                            paragraph
                            align='left'
                            dangerouslySetInnerHTML={{ __html: deleteMessage }}
                        />

                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox />}
                                label="The purchased messages will not be removed."
                                checked={keepPurchased}
                                onChange={handleKeepPurchased}
                                sx={{
                                    textAlign: 'left',
                                    lineHeight: '16px',
                                    marginRight: 0
                                }}
                            />
                        </FormGroup>

                        {
                            !keepPurchased
                                ? <Typography
                                    paragraph
                                    sx={{
                                        color: '#d32f2f',
                                    }}
                                    align='left'
                                >
                                    You may be charged a $25USD dispute fee for each dispute lodged by any subscribers who purchased the PPV. As well as reversal of payment received for the PPV.
                                </Typography>
                                : null
                        }


                    </div>
                }
                useFunction={removeStash}
                isConfirm
            />
        }
        {
            showSuccessModal && <AlertConfirmModal
                show={showSuccessModal}
                setShow={setShowSuccessModal}
                modalBody={successfulMessage}
            />
        }
    </React.Fragment >;
};

const mapStateToProps = (state) => {
    return {
        addMediaToAlbum: state.stash.addMediaToAlbum,
        show: state.stash.show,
        stash: state.stash,
        activeAlbum: state.stash.activeAlbum,
        albumAction: state.stash.albumAction,
        stashSelected: state.stash.stashSelected,
        albumList: state.stash.albums,
        stashSidebar: state.stash.stashSidebar,
        stashFilter: state.stash.filter,
        mediaFiles: state.stash.medias,
        busy: state.stash.busy,
        hasMore: state.stash.hasMore,
        broadcastModal: state.message.broadcastModal,
        convList: state.message.convList,
        mediaFilesToGetInformation: state.stash.mediaFilesToGetInformation,
        convIndex: state.message.convIndex,
        showImageModal: state.stash.showImageModal,
        showVideoModal: state.stash.showVideoModal,
        loadingStash: state.stash.busy,
        showMoveFolder: state.stash.showMoveFolder,
        userDetails: state.user.user,
        settings: state.privaGlobal.settings,
        tabSelected: state.stash.tabSelected,
        showAlbumModal: state.stash.showAlbumModal,
        orderModal: state.stash.orderModal,
        stashTempSelected: state.stash.tempSelected,
        reset: state.stash.reset,
        sort: state.stash.sort,
    };
};

export default React.memo(connect(mapStateToProps)(Stash));
